import React from 'react';

import FreePlanImage from 'assets/images/pages/plans/free_plan_table.png';

import classNames from './FreePlanModal.module.scss';
import LinkButton from '@core/components/linkbutton/LinkButton';
import ActionButton from '@core/components/actionbutton/ActionButton';

const FreePlanModal = ({ closeHandler }) => {
    return (
        <div className={classNames.wrapper}>
            <h3>You’re currently on the free plan.</h3>
            <p>
                Upgrade to access advanced learning and mentoring features
            </p>
            <img src={FreePlanImage.src} alt="Free Plan Table" />

            <LinkButton kind='primary-color' href={'/checkout?productId=1'}>Upgrade to Premium</LinkButton>
            {/* <LinkButton>View Pro Plan</LinkButton> */}

            <ActionButton kind='blank' onClick={closeHandler}>Stay on free for now</ActionButton>
        </div>
    );
};

export default FreePlanModal;